import React, { useContext } from "react";
import {
  useLocation,
  useParams,
  Navigate,
  Outlet,
  Params,
  Location,
} from "react-router-dom";
import Loader from "../components/kits/Loader/Loader.tsx"
import WithAuthentication from "context/Authentication/AuthenticationContext.ts"
interface UserInformation {
  token: string;
  fullName: string;
  userType: number;
  mobile: number;
  userName: string;
  accessLevel: any;
  id: any;
}
type checkAccessParameters = {
  location: Location;
  params: Readonly<Params<string>>;
  isLogged: boolean;
  userInfo: UserInformation;
};

/**
 * Checks user access for pages
 *
 * @param {checkAccessParameters} data - entry data
 * @returns {boolean} whether the user has access or not.
 */
function checkAccess({
  location,
  params,
  isLogged,
  userInfo,
}: checkAccessParameters): boolean {
  const { pathname } = location;
console.log({isLogged});
console.log({userInfo});

  if (pathname.includes("/admin-panel") && !isLogged) {
    return false;
  }
  if (pathname.includes("/customer-panel") && !isLogged) {
    return false;
  }
  if (pathname.includes("/admin-panel") && userInfo.userType === 1) {
    return false;
  }
  if (pathname.includes("/customer-panel") && userInfo.userType === 0) {
    return false;
  }
  if (userInfo.userType === -1) {
    return false;
  }
  return true;
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { userInfo, isLogged, isChecked } = useContext(WithAuthentication);
  const location = useLocation();
  const params = useParams();
  console.log({isChecked});
  
  if (!isChecked) {
    return (
      <div className="min-vh-100 min-vw-100 d-flex justify-content-center align-items-center">
          <Loader width={40} />
        </div>
    );
  }

  let flag = checkAccess({
    location,
    params,
    isLogged,
    userInfo,
  });

  if (flag === true) {
    return children ? children : <Outlet />;
  }
  return <Navigate to="/" />;
}

export default ProtectedRoute;
